define(function (require) {
	"use strict";

	var LE = require("app");
	var Template = require("personalization-web-agent-templates/csatEdit.tmpl");
	var Button = require("ui/button/Button");
	var toggleButton = require("ui/toggle-button/toggleButton");
	var positionsUtility = require("personalization-utils/positionsUtility");
	var Settings = require("codeTables/settings.json");

	var CsatEditView = {};

	LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
		CsatEditView = Marionette.ItemView.extend({
			template: Template,
			className: "csat-edit-container anchor",
			ui: {
				cancelButton: ".cancel-edit",
				saveButton: ".save-edit",
				editContainer: ".edit-container",
				csatToggleButton: ".csat-state-container .csat-state-value"
			},
			uiComponents: {
				cancelButton: {
					type: Button,
					options: {
						el: "view.ui.cancelButton",
						permutation: Button.PERMUTATION.LINK
					},
					events: {
						"click": "_cancel"
					}
				},
				saveButton: {
					type: Button,
					options: {
						el: "view.ui.saveButton",
						permutation: Button.PERMUTATION.BTN_PRIMARY
					},
					events: {
						"click": "_save"
					}
				},
				csatVisible: {
					type: toggleButton,
					options: {
						transition: toggleButton.TRANSITION.FAST,
						container:"view.ui.csatToggleButton",
						permutation: toggleButton.PERMUTATION.NIGHT_THEME
					}
				}
			},
			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "CsatEditView:initialize. options = " + options);
				this.anchorSelector = options.anchorSelector;
                this.siteSettingsModel = options.siteSettingsModel;
			},
			onRender: function () {
				LEPersonalization.logger.info("rendering", "CsatEditView:onRender.");
				var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.RIGHT, positionsUtility.POSITION_Y.TOP);
				this.$el.css(offset);
				this.ui.editContainer.removeClass("hide");
				this.uiComponents.csatVisible.setChecked(this._getCsatIndication());
			},
			onClose: function () {
				LEPersonalization.logger.debug("closing view", "CsatEditView:onClose.");
			},
			_cancel: function () {
				LEPersonalization.logger.debug("cancel button was pressed", "CsatEditView:_cancel.");
				LEPersonalization.navigateToPageMenu();
			},
			_save: function () {
				LEPersonalization.logger.debug("saving site settings", "CsatEditView:_save.");
				var options = {};
				options[Settings.SETTING_ID.CSAT_AGENT_VIEW] = this.uiComponents.csatVisible.isChecked();
				this.trigger("csat:save", options);
			},
			_getCsatIndication: function() {
				var csatProperty = this.siteSettingsModel.getValue();
                return (csatProperty === "true");
			}
		});
	});
	return CsatEditView;

});
